import { render, staticRenderFns } from "./adminPlanList.vue?vue&type=template&id=52783cb1&scoped=true&"
import script from "./adminPlanList.vue?vue&type=script&lang=js&"
export * from "./adminPlanList.vue?vue&type=script&lang=js&"
import style0 from "./adminPlanList.vue?vue&type=style&index=0&id=52783cb1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52783cb1",
  null
  
)

export default component.exports